export default "__VITE_ASSET__BbiP_6of__"